/* Email capture slide-up (snippets/dn-email-capture.liquid says when and why).
   Loaded before dn-cart.js so the basket's first dn:cart event, on load, is read as the baseline: anything above
   it is an add made on this page view. Storage failing (private window, blocked) means it never shows, so the
   once-per-14-days promise holds whatever the browser does. */
(function () {
  var box = document.getElementById('DnCapture');
  if (!box) return;
  var KEY = 'dn-capture-v1';
  var DAYS = 14;
  var now = Date.now();

  function seen() {
    try {
      var at = Number(window.localStorage.getItem(KEY) || 0);
      return at > 0 && now - at < DAYS * 864e5;
    } catch (e) { return true; }
  }
  function mark(until) {
    try { window.localStorage.setItem(KEY, String(until || Date.now())); } catch (e) { /* stays unseen-safe: seen() fails closed */ }
  }
  if (seen()) return;

  var shown = false;
  function show() {
    if (shown || seen()) return;
    shown = true;
    mark();
    box.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { box.classList.add('is-in'); }); });
  }
  function close() {
    box.classList.remove('is-in');
    setTimeout(function () { box.hidden = true; }, 220);
  }

  /* Trigger 1: the first add on this page view. */
  var base = null;
  document.addEventListener('dn:cart', function (e) {
    var d = (e && e.detail) || {};
    var n = (d.cartons || 0) + (d.giftCards || 0);
    if (base === null) { base = n; return; }
    if (n > base) show();
  });

  /* Trigger 2: leaving the basket page, read as a desktop pointer leaving through the top of the window. */
  if (box.getAttribute('data-cart-page')) {
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0) show();
    });
  }

  box.addEventListener('click', function (e) {
    if (e.target.closest('[data-dn-capture-close]')) close();
  });
  box.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  var form = box.querySelector('form');
  var msg = box.querySelector('[data-dn-capture-msg]');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = form.email.value.trim();
    if (!form.email.checkValidity() || !email) { msg.textContent = 'Enter an email address we can send the code to.'; form.email.focus(); return; }
    if (!form.consent.checked) { msg.textContent = 'Tick the box so we may email you the code.'; form.consent.focus(); return; }
    var btn = form.querySelector('[type=submit]');
    btn.disabled = true;
    msg.textContent = 'Sending…';
    fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(box.getAttribute('data-company')), {
      method: 'POST',
      headers: { 'content-type': 'application/vnd.api+json', revision: '2026-07-15' },
      body: JSON.stringify({ data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Basket slide-up, S$5 first order',
          profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
        },
        relationships: { list: { data: { type: 'list', id: box.getAttribute('data-list') } } }
      } })
    }).then(function (r) {
      if (!r.ok) throw new Error(String(r.status));
      mark(now + 365 * 864e5);
      form.hidden = true;
      box.querySelector('.dn-capture__no').hidden = true;
      box.querySelector('.dn-capture__title').textContent = 'Check your inbox.';
      var done = document.createElement('p');
      done.className = 'dn-capture__sub dn-meta';
      done.setAttribute('role', 'status');
      done.textContent = 'The code is on its way to ' + email + '.';
      box.appendChild(done);
    }).catch(function () {
      btn.disabled = false;
      msg.textContent = 'That did not go through. Please try again.';
    });
  });
})();
